/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Camera_Settings_Base_Url_InvalidInputs */

const vi_grower_camera_settings_base_url_invalid = /** @type {(inputs: Grower_Camera_Settings_Base_Url_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Địa chỉ máy chủ phải bắt đầu bằng http:// hoặc https://`)
};

/**

* @param {Grower_Camera_Settings_Base_Url_InvalidInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_camera_settings_base_url_invalid = /** @type {((inputs?: Grower_Camera_Settings_Base_Url_InvalidInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Camera_Settings_Base_Url_InvalidInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_camera_settings_base_url_invalid(inputs)
});